import { colors } from 'ui/theme';
import { CustomNode } from '../../../types';

export const DELAY_BASE_ACCENT_COLOR = colors.salmon50;
export const DELAY_BASE_BACKGROUND_ACCENT_COLOR = colors.salmon50;
export const DELAY_BASE_BORDER_ACCENT_COLOR = colors.salmon50;
export const DELAY_BASE_DEFAULT_TITLE = 'Modify journey';

export const delayBaseConfig: CustomNode = {
  getCustomConfig(model) {
    return {
      defaultTitle: DELAY_BASE_DEFAULT_TITLE,
      accentColor: DELAY_BASE_ACCENT_COLOR,
      activeBorderColor: DELAY_BASE_BORDER_ACCENT_COLOR,
      accentColorBackground: DELAY_BASE_BACKGROUND_ACCENT_COLOR,
      ...this.getNodeConfig(model),
    };
  },

  getNodeConfig() {
    return {};
  },
};
